<template>
  <!-- Grid do Produtos -->
  <div class="products">
    <div class="header form-inline mb-3">
      <div class="form-inline">
        <h4 class="mr-5">Cadastro de Produtos</h4>
        <button class="btn btn-primary" @click="newProduct()">Novo Produto</button>
      </div>
      <div>
        <input class="form-control mr-2" type="text" placeholder="Informe o produto" v-model="search">
        <button class="btn btn-outline-primary" type="button" @click="getProducts()">Localizar</button>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <table class="table">
          <thead class="thead">
            <tr>
              <th scope="col">Nome</th>
              <th scope="col" class="text-right">Preço</th>
              <th scope="col">Aplicações</th>
              <th scope="col" class="text-center">Promoção</th>
              <th scope="col" class="text-center">Indisponível</th>
              <th scope="col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product, index) in products" :key="index">
              <td>{{ product.name }}</td>
              <td class="text-right"><span v-money-format="product.price" /></td>
              <td>{{ product.application }}</td>
              <td class="text-center">{{ product.promotion ? 'Sim' : 'Não' }}</td>
              <td class="text-center">{{ product.unavailable ? 'Sim' : 'Não' }}</td>
              <div class="btn-group">
                <td>
                  <button class="btn btn-outline-secondary" @click="updateProduct(product)">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                </td>
                <td class="text-center">
                  <button class="btn btn-outline-danger" @click="deleteProduct(product.id, product.fileName)">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Form Modal -->
    <div class="product">
      <div class="productModal" :style="{ display: showModal ? 'block' : 'none' }">
        <form>
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Produto</h5>
                <span class="close" @click="closeModal()">&times;</span>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="form-group col-8">
                    <label>Nome</label>
                    <input type="text" class="form-control" v-model="product.name"/>
                  </div>
                  <div class="form-group col-4">
                    <label>Preço</label>
                    <input type="text" class="form-control" v-model="product.price"/>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label>Aplicação</label>
                    <textarea class="form-control" rows="4" v-model="product.application"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12 mt-2">
                    <input type="file" class="d-none" accept=".jpg, .jpeg" ref="inputFile" @change="handleFile($event)">
                    <button type="button" class="btn btn-outline-secondary" @click="openFileDialog()">
                      Adicionar Foto
                    </button>
                    <button type="button" class="btn btn-outline-danger ml-2" v-if="(file || product.fileName)"
                      @click="deleteFile()">
                      <i class="fas fa-trash"></i>
                    </button>
                    <div v-if="(file && !product.fileName)" class="mt-2">
                      {{ file.name }}
                    </div>
                    <div v-if="(product.fileName && !file)" class="mt-2">
                      {{ product.fileName }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12 mb-n1">
                    <div class="form-group form-check">
                      <input type="checkbox" class="form-check-input" v-model="product.promotion">
                      <label class="form-check-label">Produto em Promoção</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12 mb-n1">
                    <div class="form-group form-check">
                      <input type="checkbox" class="form-check-input" v-model="product.unavailable">
                      <label class="form-check-label">Produto Indisponível</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer mt-3">
                <button class="btn btn-secondary" @click.prevent="cancel()">
                  Cancelar
                </button>
                <button class="btn btn-primary" @click.prevent="saveProduct()">
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Products',
  data: () => ({
    products: [],
    search: '',
    product: {
      id: '',
      name: '',
      price: '',
      application: '',
      fileName: '',
      fileURL: '',
      unavailable: false,
      promotion: false
    },
    showModal: false,
    ref: '',
    file: ''
  }),
  methods: {
    getProducts () {
      this.$firebase.database().ref('products').orderByChild('name').startAt(this.search).endAt(`${this.search}\uf8ff`)
        .on('value', (data) => {
          const values = data.val()
          if (values !== null) {
            this.products = Object.keys(values).map((items) => values[items]).sort(this.order)
          } else this.products = []
        })
      this.search = ''
    },
    order (a, b) {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    },
    newProduct () {
      this.showModal = true
    },
    updateProduct (object) {
      this.product = object
      this.showModal = true
    },
    async deleteProduct (id, fileName) {
      const resultado = confirm('Deseja excluir o produto?')
      if (resultado === true) {
        await this.$firebase.database().ref(`products/${id}`)
          .remove().then(() => {
            if (fileName) {
              this.$firebase.storage().ref()
                .child(`products/${fileName}`)
                .delete()
            }

            this.$root.$emit('Notification::show', {
              message: 'Produto removido com sucesso.',
              type: 'success'
            })
          }).catch(() => {
            this.$root.$emit('Notification::show', {
              message: 'Não foi possivel exlcuir o produto, tente novamente.',
              type: 'danger'
            })
          })
      }
    },
    async saveProduct () {
      if (this.validation()) {
        this.$root.$emit('Spinner::show')
        let url = ''

        try {
          this.ref = this.$firebase.database().ref('products')

          if (!this.product.id) {
            this.product.id = this.ref.push().key
          }

          if (this.file) {
            const file = this.file.name
            const split = file.split('.')
            const fileSplit = `${split[0]}-${new Date().getTime()}.${split[1]}`
            const snapshot = await this.$firebase.storage().ref('products')
              .child(fileSplit)
              .put(this.file)

            url = await snapshot.ref.getDownloadURL()

            this.product.fileName = fileSplit
            this.product.fileURL = url
          }

          const payload = {
            ...this.product
          }

          if (payload.price) {
            payload.price = payload.price.replace(',', '.')
          }

          this.ref.child(this.product.id).set(payload, (err) => {
            if (err) {
              this.$root.$emit('Notification::show', {
                message: 'Não foi possivel inserir o produto, tente novamente.',
                type: 'danger'
              })
            } else {
              this.$root.$emit('Notification::show', {
                message: 'Produto salvo com sucesso.',
                type: 'success'
              })
              this.closeModal()
            }
          })
        } catch (error) {
          this.$root.$emit('Notification::show', {
            message: 'Não foi possivel inserir o produto, tente novamente.',
            type: 'danger'
          })
          console.log(error)
        }
        this.$root.$emit('Spinner::hide')
      }
    },
    cancel () {
      this.closeModal()
      this.getProducts()
    },
    closeModal () {
      this.product = {}
      this.file = ''
      this.showModal = false
    },
    openFileDialog () {
      this.$refs.inputFile.value = null
      this.$refs.inputFile.click()
    },
    handleFile (event) {
      this.file = event.target.files[0]
    },
    deleteFile () {
      const resultado = confirm('Deseja excluir a foto?')
      if (resultado === true) {
        this.file = ''
        this.product.fileName = ''
        delete this.product.fileURL
      }
    },
    validation () {
      if (!this.product.name) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar nome.',
          type: 'warning'
        })
      } else if (!this.product.price) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar preço.',
          type: 'warning'
        })
      } else {
        return true
      }
    }
  },
  created () {
    this.getProducts()
  }
}
</script>

<style lang="scss" scoped>
.products {
  padding: 40px 60px;
  height: 100%;
  .header {
      display: flex;
      justify-content: space-between;
  }
}
.product {
  .productModal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    form {
      .close {
        &:hover {
          color: #000;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
